<template>
  <div class="social-login">
    <h2 class="logintype">With an existing account:</h2>
    <button type="button" class="button button-block uppercase social google" :class="{ disabled: disabled }" @click="oauthLogin('google')" aria-label="Login with existing google account">
      <GoogleIcon class="logo" />
      Google
    </button>
    <button type="button" class="button button-block uppercase social fb" :class="{ disabled: disabled }" @click="oauthLogin('facebook')" aria-label="Login with existing facebook account">
      <FacebookIcon class="logo" />
      Facebook
    </button>
    <p class="center disclaimer">
      By Continuing with Google or Facebook, you are agreeing to our <a href="/tou" target="_blank">Terms &amp; Conditions</a>.
    </p>
  </div>
</template>

<script>
import FacebookIcon from '@/assets/login/facebook.svg';
import GoogleIcon from '@/assets/login/google.svg';
import { Step } from '@/pages/Auth/AuthNavigation';
import Tracking from '@/components/commons/Tracking.js';
import { UrlUtils } from '@/pixel/index';

export default {
  props: ['onComplete', 'extra', 'disabled', 'trackPage'],
  components: {
    FacebookIcon,
    GoogleIcon,
  },
  methods: {
    async oauthLogin(provider) {
      const w = 600;
      const h = 660;

      const left = window.outerWidth / 2 - w / 2 + window.screenX;
      const top = window.outerHeight / 2 - h / 2 + window.screenY;

      window.onOauthResult = (result) => {
        delete window.onOauthResult;

        if (this.trackPage && result.success) {
          const trackData = {
            page: this.trackPage,
            isSignup: result.step === Step.SIGN_UP_SOCIAL,
            provider,
          };
          Tracking.track('social-login', trackData);
        }

        this.onComplete(result);
      };

      this.errors = {};

      const url = `${UrlUtils.substitute('/oauth/login/:provider', { provider })}?${UrlUtils.parametersToQueryString(this.extra || {})}`;

      const loginDialog = window.open(
        url,
        `Login With ${provider}`,
        `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=${w},height=${h},left=${left},top=${top}`,
      );

      // loginDialog.onunload = function(){
      //   delete window.onOauthResult;
      //   // other actions? error message?
      //  };
    },
  },
};
</script>

<style lang="postcss">
h2.logintype {
  text-transform: none;
  margin-bottom: var(--space-4);
  letter-spacing: 0px;
  color: var(--grey-medium);
}

.social-login {
  p.disclaimer {
    font-size: var(--font-size-12) !important;
    line-height: 1.75em !important;
  }

  button.button.social {
    width: 100%;
    margin: var(--space-4) 0;
    border: 1px solid var(--grey-light);
    background: var(--white);
    color: var(--grey-medium);
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: var(--space-2);
    padding-top: var(--space-2);

    .logo {
      width: var(--font-size-24);
      height: var(--font-size-24);
      margin-right: var(--space-3);
    }
    /* purgecss ignore */
    &:hover {
      /* purgecss ignore */
      &:not(:active),
      &:active {
        border: 1px solid var(--grey-light);
        background: var(--grey-ultra-light);
        color: var(--grey-medium);
      }
    }
  }
}
</style>
